// eslint-disable-next-line import/prefer-default-export
export const createGameUrl = (gameName: string, roomId: string) => {
  const queryString = `/${gameName}?roomId=${roomId ?? "offline game&offline=true"}`;
  return queryString;
};
